export const blocosKeys = {
  blocos: ['blocos'] as const,
  listas: () => [...blocosKeys.blocos, 'lista'] as const,
  lista: (empreendimentoId: string) => [...blocosKeys.listas(), { empreendimentoId }] as const,
  disponiveis: (empreendimentoId: string, simulacaoId: string) =>
    [...blocosKeys.lista(empreendimentoId), simulacaoId, 'disponiveis'] as const,
}
